/**
 * Real Client Reviews — slider controller.
 * Handles: drag-to-scroll, arrow buttons, dot navigation, autoplay,
 * and keeps dots in sync when the visitor scrolls/swipes manually.
 */
(function () {
  'use strict';

  function initReviews(root) {
    var track = root.querySelector('.reviews__track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.reviews__card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.reviews__dot'));
    var prevBtn = root.querySelector('.reviews__arrow--prev');
    var nextBtn = root.querySelector('.reviews__arrow--next');

    if (!track || cards.length === 0) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var current = 0;

    function cardStep() {
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return cards[0].getBoundingClientRect().width + gap;
    }

    function updateDots(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: cardStep() * current, behavior: 'smooth' });
      updateDots(current);
    }

    function next() {
      goTo(current + 1 >= cards.length ? 0 : current + 1);
    }

    function prev() {
      goTo(current - 1 < 0 ? cards.length - 1 : current - 1);
    }

    function start() {
      stop();
      if (autoplay) timer = setInterval(next, speed);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    // Keep dots in sync with manual swipe/scroll.
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var index = Math.round(track.scrollLeft / cardStep());
        current = Math.max(0, Math.min(index, cards.length - 1));
        updateDots(current);
      }, 100);
    });

    // Pointer-drag support for mouse users (touch works natively).
    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      stop();
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });

    function endDrag() {
      isDown = false;
      track.classList.remove('is-dragging');
      start();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    updateDots(0);
    start();

    window.addEventListener('resize', function () {
      goTo(current);
    });
  }

  function initAll() {
    document.querySelectorAll('.reviews--slider').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('.reviews--slider');
    if (section) initReviews(section);
  });
})();
